import BaseModel from '../BaseModel';

export default class AiQuestion extends BaseModel {
  static entity = 'aiQuestions';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      vacancyId: this.attr(null),
      status: this.string(null),
      text: this.string(null),
      questionOrder: this.number(null),
      avatar: this.string(null),
    };
  }

  static apiConfig = {
    actions: {
      getQuestions(vacancyId, payload) {
        return this.get(`ai_interview/questions/${vacancyId}`, {
          params: payload,
        });
      },
      updateQuestions(vacancyId, payload) {
        return this.patch(`ai_interview/questions/${vacancyId}`, payload);
      },
      confirm(vacancyId, payload) {
        return this.post(`ai_interview/questions/${vacancyId}/confirm`, payload, { save: false });
      },
    },
  }
}
